module.exports = __webpack_public_path__ + "static/media/instagram.c6b213b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/instagram.png
// module id = 4
// module chunks = 0